module.exports = __webpack_public_path__ + "media/video1.995174a1.mp4";